import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './styles.less'
import TableAllProject from '../../widgets/tableAllProject/TableAllProject'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import DashboradToggle from '../../widgets/dashboard/DashboradToggle'

export default function ApproveWithdrawReviewProjectDashboard({
  config,
  onSettingChange = () => {},
}) {
  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchema()
    }
  }, [])

  const handelGetSchema = async () => {
    setIsLoading(true)
    try {
      // const response = await getAllProject(5, 1)
      // console.log('res xxx => ', response)
      setSchema(mockSchema)
    } catch (e) {
      console.error('Error ', e)
      setError({})
    }
    setIsLoading(false)
  }

  const handleSearchProject = async (pagesize, pagenumber, projectcode, projectname) => {
    console.log('handleSearchProject ', pagesize, pagenumber, projectcode, projectname)
    // startLoading()
    // setloading(true)
    // try {
    //   const response = await searchAllProject(pagesize, pagenumber, projectcode, projectname)

    //   if (response) {
    //     setSchema(response)
    //   }
    // } catch (e) {
    //   console.log('e', e)
    // }
    // setloading(false)
    // doneLoading()
  }

  const handleGetSchemaDashboard = async (pagesize, pagenumber, projectcode, projectname) => {
    console.log('handleGetSchemaDashboard ', pagesize, pagenumber, projectcode, projectname)
    // startLoading()
    // setloading(true)
    // try {
    //   // const response = await getAllProject(pagesize, pagenumber)
    //   const response = await searchAllProject(pagesize, pagenumber, projectcode, projectname)
    //   if (response) {
    //     setSchema(response)
    //   }
    // } catch (e) {
    //   console.log('e', e)
    // }
    // setloading(false)
    // doneLoading()
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <TableAllProject
            schema={schema}
            subName={{ enable: true }}
            // muti={{ enable: false, buttonText: `ไปยังการ${schema?.mutiButtonText || 'กลั่นกรอง'}` }}
            single={{
              enable: true,
              buttonText: schema?.buttonText || 'กลั่นกรอง',
              icon: schema?.singleIcon,
            }}
            // onSingleSubmit={onSingleSubmit}
            // onMutiSubmit={onMutiSubmit}
            pagination={true}
            onReload={handleGetSchemaDashboard}
            loading={isLoading}
            hiddenColStatus={true}
            searchRows={{ enable: true }}
            onSearchProject={handleSearchProject}
            showContractNo={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'อนุมัติเบิกจ่ายเงินทบทวนโครงการ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectStatusText: 'สถานะ',
  projectEditVerText: 'แก้ไขล่าสุด',
  totalSize: 154,
  values: [
    {
      projectVersionId: '',
      code: 'XX-XXXXX',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: {
        name: 'โครงการ XXXXXX',
        statusName: 'สถานะ XXXX',
      },
      status: 'สถานะ XXXX',
      colorstatus: { code: '#B5EAD6', label: 'อนุมัติ' },
      date: 'V.X DD/MM/YYYY HH:MM',
      contractNo: 'XX-XX-XXXX',
    },
  ],
}

const mockSchema = {
  header: 'อนุมัติเบิกจ่ายเงินทบทวนโครงการ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectStatusText: 'สถานะ',
  projectEditVerText: 'แก้ไขล่าสุด',
  totalSize: 5,
  values: [
    {
      projectVersionId: 'AF468445-F224-41FF-A1C0-4CF1D090FEBB',
      code: '65-10050',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: {
        name: 'พฤติกรรมการบริโภคอาหารของนิสิตชั้นปีที่ 1  หลักสูตรโภชนาการและการกำหนดอาหาร คณะวิทยาศาสตร์การแพทย์มหาวิทยาลัยพะเยา',
        statusName: 'อยู่ระหว่างลงนามในสัญญา',
      },
      status: 'อนุมัติ',
      colorstatus: { code: '#B5EAD6', label: 'อนุมัติ' },
      date: 'V. 6 12/05/2565 21:29',
      contractNo: '65-E2-0071',
    },
    {
      projectVersionId: 'C757BB62-F122-4EEC-B947-690D879D672E',
      code: '65-10031',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: {
        name: 'ป้องกันภัยออนไลน์ 04',
        statusName: 'นักวิชาการเสนอผู้อำนวยการสำนักให้ความเห็นชอบลงนามสัญญา/ข้อตกลง',
      },
      status: 'อนุมัติ',
      colorstatus: { code: '#B5EAD6', label: 'อนุมัติ' },
      date: 'V. 4 09/05/2565 15:31',
      contractNo: '65-E1-0056',
    },
    {
      projectVersionId: '4835D487-1FB3-49AD-8E83-B44EFE8A60FE',
      code: '65-10023',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: {
        name: 'ป้องกันภัยออนไลน์ 02',
        statusName: 'ผู้มีอำนาจอนุมัติ อนุมัติยุติโครงการ',
      },
      status: 'ยุติโครงการ',
      colorstatus: { code: '#A3E1DC', label: 'ยุติโครงการ' },
      date: 'V. 6 09/05/2565 10:58',
      contractNo: '65-E2-0051',
    },
    {
      projectVersionId: '5E882C79-9449-48A6-A288-24E608D77212',
      code: '65-10013',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: {
        name: 'เดินลดพุง 1',
        statusName: 'นักวิชาการเสนอผู้อำนวยการสำนักให้ความเห็นชอบลงนามสัญญา/ข้อตกลง',
      },
      status: 'อนุมัติ',
      colorstatus: { code: '#B5EAD6', label: 'อนุมัติ' },
      date: 'V. 4 06/05/2565 17:30',
      contractNo: '65-E1-0052',
    },
    {
      projectVersionId: 'E6B00AF6-686C-4D85-8B8C-2C9D2C5E139E',
      code: '65-10027',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: { name: ' ทดสอบส่งเมล 02', statusName: 'ภาคี ไม่ทำสัญญา/ข้อตกลง' },
      status: 'อนุมัติ',
      colorstatus: { code: '#B5EAD6', label: 'อนุมัติ' },
      date: 'V. 7 06/05/2565 16:56',
      contractNo: '65-E1-0053',
    },
  ],
}
